import { render, staticRenderFns } from "./m-dot.vue?vue&type=template&id=6dba5ba9&scoped=true&"
import script from "./m-dot.vue?vue&type=script&lang=js&"
export * from "./m-dot.vue?vue&type=script&lang=js&"
import style0 from "./m-dot.vue?vue&type=style&index=0&id=6dba5ba9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba5ba9",
  null
  
)

export default component.exports